<template lang='pug'>
  .new-password
      .section
        .container
          .columns
            .column
              .block-center
                h2 {{ gettext('New password') }}
                h3 {{ gettext('You must enter a new password') }}
                .field
                  .field-body.has-icon
                    i.mdi.mdi-lock
                    input(
                      type='password'
                      name='newPassword'
                      v-model='form.new_password1'
                      :placeholder="gettext('New password')"
                      :class="{'is-danger': $v.form.new_password1.$error }"
                      @focus="$v.form.new_password1.$touch()")
                .field(
                  v-tooltip="{content: (errors.backend || {}).new_password2 || errors.new_password2, show: $v.form.new_password2.$error}"
                )
                  .field-body.has-icon
                    i.mdi.mdi-lock
                    input(
                      type='password'
                      name='newPasswordRepeat'
                      v-model='form.new_password2'
                      :placeholder="gettext('Repeat new password')"
                      :class="{'is-danger': $v.form.new_password2.$error }"
                      @focus="$v.form.new_password2.$touch(), setErrorsText()")
                .field
                  .field-body
                    button.main-btn.col-white.bg-red(:disabled="!formIsValid" @click="send") {{ gettext('Send') }}
</template>

<script>
import Vue from 'vue'
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import Vuelidate from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import mixin from '@/mixins'
const _ = require('lodash')

Vue.use(Vuelidate)
Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'NewPassword',
  mixins: [
    mixin
  ],
  data () {
    return {
      form: {
        new_password1: '',
        new_password2: ''
      },
      token: this.$route.query.token,
      errors: {backend: {}}
    }
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  validations: {
    form: {
      new_password1: {
        required
      },
      new_password2: {
        required,
        sameAsPassword: sameAs('new_password1')
      }
    }
  },
  methods: {
    ...mapActions([
      'setNewPassword'
    ]),
    gettext: gettext,
    send () {
      const data = {
        new_password1: this.form.new_password1,
        new_password2: this.form.new_password2
      }
      this.setNewPassword({lang: this.getLanguage, data: data, token: this.token}).then(() => {
        this.$router.push({name: 'Login', lang: this.getLanguage})
      }).catch(err => {
        if ((err.data || {}).form_errors) {
          this.errorProcessor(err.data.form_errors)
        } else {
          this.$router.push({name: 'ForgotPassword', lang: this.getLanguage})
        }
      })
    },
    setErrorsText () {
      this.errors = {
        new_password2: gettext('This field is required. Password does not match.')
      }
    },
    errorProcessor (errors) {
      _.each(errors, (item, key) => {
        this.form.new_password1 = ''
        this.form.new_password2 = ''
        this.$set(this.errors, 'backend', {
          [key]: item[0]['message']
        })
        setTimeout(() => {
          this.errors = {}
        }, 4000)
        this.$v.$touch()
      })
    }
  },
  watch: {
    getLanguage: function () {
      this.setErrorsText()
    }
  },
  created () {
    this.setErrorsText()
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('New password'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    }
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/auth/new-password/index.vue